import { useRef } from 'react'

export default function useDebounce() {
  const timeoutRef = useRef<NodeJS.Timeout>()

  const debounce = (callback: (params?: any) => void, delay = 1000) => {
    clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(callback, delay)
  }

  return { debounce }
}
